export default "__VITE_ASSET__Ccu$6pNk__"